import { googleLogout } from "@react-oauth/google";
import AuthenticationService from "./authenticationService";
import { setAuthentication } from "./authenticationHelpers";
import authorizeService from "../authorizeService";
import AuthorizationProvider from "../../enums/authorizationProvider";
import store from "../../store";
import LocalStorage from "../../helpers/localStorage";
export class GoogleAuthenticationService extends AuthenticationService {
    constructor(authorizationProvider) {
        super();
        this.tokenData = null;
        this.initialize = async () => {
            const storedTokenData = await LocalStorage.retrieveAsync(this.authorizationProvider);
            if (!storedTokenData) {
                return;
            }
            setAuthentication(this);
            this.tokenData = storedTokenData;
            this.loginUserAndFetchAccessDetails({ username: this.tokenData.email });
        };
        this.signIn = async (authorizationCode) => {
            setAuthentication(this);
            store.auth.setIsAppLoading(true);
            await this.fetchAndPersistTokenData(authorizationCode);
            store.auth.setIsAppLoading(false);
        };
        this.logOut = async () => {
            googleLogout();
            await LocalStorage.removeAsync(this.authorizationProvider);
        };
        this.acquireUserToken = async () => {
            if (!this.tokenData) {
                this.handleError();
                return;
            }
            if (new Date(this.tokenData.expiresAt) > new Date()) {
                return this.tokenData.accessToken;
            }
            store.auth.setIsAppLoading(true);
            const accessToken = await this.refreshToken();
            this.loginUserAndFetchAccessDetails({ username: this.tokenData.email });
            store.auth.setIsAppLoading(false);
            return accessToken;
        };
        this.fetchAndPersistTokenData = async (authorizationCode) => {
            const tokenData = await authorizeService.exchangeAccessCodeForToken({
                authorizationCode,
                provider: this.authorizationProvider,
                redirectUrl: this.getRedirectUrl()
            });
            if (!tokenData) {
                this.handleError();
                return;
            }
            await LocalStorage.storeAsync(this.authorizationProvider, tokenData);
            this.tokenData = tokenData;
            this.loginUserAndFetchAccessDetails({ username: tokenData.email });
        };
        this.refreshToken = async () => {
            setAuthentication(null);
            const tokenData = await authorizeService.refreshToken({
                refreshToken: this.tokenData.refreshToken,
                provider: this.authorizationProvider
            });
            if (!tokenData) {
                this.handleError();
                return;
            }
            setAuthentication(this);
            await LocalStorage.storeAsync(this.authorizationProvider, tokenData);
            this.tokenData = tokenData;
            return tokenData.accessToken;
        };
        this.handleError = () => {
            store.auth.setHasError(true);
            this.logOut();
        };
        this.getRedirectUrl = () => location.origin + location.pathname;
        this.authorizationProvider = authorizationProvider;
        this.initialize();
    }
}
export const veoliaAuthenticationService = new GoogleAuthenticationService(AuthorizationProvider.Veolia);
